import { Box, ButtonBase, Typography } from '@mui/material';
import { WD } from '../../../warningDashboard/warningTheme';
import { FIGURE, HOVER_BG, LEVEL_TONE } from '../utils/constants';
import { fmtHours } from '../utils/hours';

/** One project in the projects panel - hours, tasks, people, overdue. Clicking filters the page to it (again clears it). */
export default function ProjectButton({ project, hours, selected, onSelect }) {
  return (
    <ButtonBase
      aria-pressed={selected}
      onClick={() => onSelect(project.projectId)}
      sx={{ display: 'block', textAlign: 'left', borderRadius: 2, px: 1.25, py: 1, bgcolor: selected ? WD.greenTint : 'transparent', '&:hover': { bgcolor: selected ? WD.greenTint : HOVER_BG } }}
    >
      <Typography noWrap sx={{ fontSize: 13, fontWeight: 600, color: selected ? WD.green : WD.ink }}>{project.name}</Typography>
      <Typography sx={{ mt: 0.25, fontSize: 11.5, color: WD.inkFaint, ...FIGURE }}>
        {fmtHours(hours)} · {project.tasks} task{project.tasks === 1 ? '' : 's'} · {project.people} {project.people === 1 ? 'person' : 'people'}
        {project.overdue > 0 && <Box component="span" sx={{ color: LEVEL_TONE.overloaded.text, fontWeight: 600 }}> · {project.overdue} overdue</Box>}
      </Typography>
    </ButtonBase>
  );
}
